import {
  Container,
  SectionContainer,
  Divider,
  Title,
  LabeledAmountCell,
  LabeledAmountTitle,
  LabeledAmountValue,
  CellMathSymbol,
  ItemRow,
  ItemKey,
  ItemValue,
} from "./LoanDetails.styles";
import {
  AddMoneySelected,
  MoneyReceiveSelected,
  MoneySecurity,
} from "src/assets/icons";
import { formatNumberForCurrency } from "src/utils";

export default ({
  totalAmount = 0,
  loanAmount = 0,
  downPaymentAmount = 0,
  estimatedMonthlyPayment = 0,
}) => {
  return (
    <Container>
      <Title>Loan details</Title>
      <SectionContainer>
        <ItemRow>
          <LabeledAmountCell>
            <LabeledAmountTitle>
              Unpaid <AddMoneySelected />
            </LabeledAmountTitle>
            <LabeledAmountValue>
              ${formatNumberForCurrency(loanAmount)}
            </LabeledAmountValue>
          </LabeledAmountCell>
          <CellMathSymbol>+</CellMathSymbol>
          <LabeledAmountCell>
            <LabeledAmountTitle>
              Down payment <MoneyReceiveSelected />
            </LabeledAmountTitle>
            <LabeledAmountValue>
              ${formatNumberForCurrency(downPaymentAmount)}
            </LabeledAmountValue>
          </LabeledAmountCell>
          <CellMathSymbol>=</CellMathSymbol>
          <LabeledAmountCell>
            <LabeledAmountTitle>
              Total <MoneySecurity />
            </LabeledAmountTitle>
            <LabeledAmountValue isBold>
              ${formatNumberForCurrency(totalAmount)}
            </LabeledAmountValue>
          </LabeledAmountCell>
        </ItemRow>
        <Divider />
        <ItemRow>
          <ItemKey>Total estimated monthly payments</ItemKey>
          <ItemValue>
            ${formatNumberForCurrency(estimatedMonthlyPayment)}
          </ItemValue>
        </ItemRow>
      </SectionContainer>
    </Container>
  );
};
